import axios from 'axios';
import camelize from 'camelize-ts';
import snakecaseKeys from 'snakecase-keys';
const EXPERIMENT_RELAY_PROD_URL = 'https://api.squareup.com/1.0/experimentation';
const EXPERIMENT_RELAY_STAGE_URL = 'https://api.broadway.squareup.com/1.0/experimentation';
export function create(useProductionEndpoint) {
    const axiosExtend = axios.create({
        baseURL: useProductionEndpoint ? EXPERIMENT_RELAY_PROD_URL : EXPERIMENT_RELAY_STAGE_URL,
    });
    // Axios middleware to convert all api responses to camelCase
    axiosExtend.interceptors.response.use((response) => {
        if (response.data && response.headers['content-type'].includes('application/json')) {
            response.data = camelize(response.data);
        }
        return response;
    });
    // Axios middleware to convert all api requests to snake_case
    axiosExtend.interceptors.request.use((config) => {
        if (config.params) {
            config.params = snakecaseKeys(config.params, { deep: true });
        }
        if (config.data) {
            config.data = snakecaseKeys(config.data, { deep: true });
        }
        return config;
    });
    return axiosExtend;
}
